// Штабные цвета карты (встреча 03.09.2026). Основные — чёрный, красный, синий;
// жёлтый, зелёный, коричневый — реже. Общие для сайдбара и панели знака.
export const MAP_COLORS = [
  { value: '#000000', label: 'Чёрный' },
  { value: '#DC2626', label: 'Красный' },
  { value: '#2563EB', label: 'Синий' },
  { value: '#EAB308', label: 'Жёлтый' },
  { value: '#16A34A', label: 'Зелёный' },
  { value: '#854D0E', label: 'Коричневый' },
]
